<template>
<div>
  <v-app>
    <v-toolbar
      color="blue darken-4"
      dark
      tabs
      class="hidden-xs-only"
    >
      <v-toolbar-title class="desktop_title">Cleary Consolidated Central Vacuums</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tabs
        slot="extension"
        color="blue darken-4"
        v-model="tab"
        grow
      >
        <v-tabs-slider color="white"></v-tabs-slider>

        <v-tab to="/" router>Home</v-tab>
        <!-- <v-tab to="/centralvac" router>Central Vacs</v-tab> -->
        <v-tab to="/bids" router>Get A Quote</v-tab>
        <v-tab to="/contact" router>Contact</v-tab>
      </v-tabs>
    </v-toolbar>
    <v-toolbar
      color="blue darken-4"
      dark
      tabs
      class="hidden-sm-and-up"
    >
      <v-menu :nudge-width="100">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        
        <v-list>
          <v-list-tile to="/" router>
            <v-list-tile-title>Home</v-list-tile-title>
          </v-list-tile>
          <!-- <v-list-tile to="/centralvacs" router>
            <v-list-tile-title>Central Vacs</v-list-tile-title>
          </v-list-tile> -->
          <v-list-tile to="/bids" router>
            <v-list-tile-title>Get A Quote</v-list-tile-title>
          </v-list-tile>
          <v-list-tile to="/contact" router>
            <v-list-tile-title>Contact</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-toolbar-title>Cleary Consolidated Central Vacuums</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout align-center justify-start column fill-height>
        <router-view/>
      </v-layout>
    </v-content>
    <v-footer
      dark
      height="auto"
    >
      <v-card
        class="flex"
        flat
        tile
      >
        <v-card-title class="blue darken-4" >
          <v-spacer class="hidden-xs-only"></v-spacer>
          <strong class="subheading">Connect with us!</strong>
          <v-btn
            v-for="icon in icons"
            :key="icon"
            class="mx-3"
            dark
            icon
            @click=handleIconClick
          >
            <v-icon size="24px">{{ icon }}</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-actions class="grey darken-3 justify-center">
          &copy;2019 — Cleary Consolidated Central Vacuums. All rights reserved.
        </v-card-actions>
      </v-card>
    </v-footer>
  </v-app>
</div>
</template>
<script>
  import axios from 'axios';
  import store from './store';
  import { mapActions } from 'vuex';

  export default {
    data() {
      return {
        tab: null,
        icons: [
          'fab fa-facebook',        
        ],
        companyName: "Cleary Consolidated Central Vacuums",
      }
    },
    methods: {
      setLocations: function (results) {
        //store.dispatch('setLocations', results);
      },
      handleIconClick: function (e) {
        console.log(e);
        window.open('https://www.facebook.com/clearyvacuum/');
      }
    },
    mounted: function () {
      var that = this;
      /* axios.get('http://192.168.1.182:3000/posi/api/locations/public')
        .then(function (result) {
          that.setLocations(result.data);
        })
        .catch(function (error) {
          console.log(error.message);
        }); */

      
    }
  }
</script>
<style lang="scss">
html {
  overflow-y: auto;
}
#app {
  font-family: 'Open Sans',sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.desktop_title {
  font-size: xx-large;
}
</style>
